import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import DepartmentForm from '../components/department/DepartmentForm';
import DepartmentTable from '../components/department/DepartmentTable';

const DepartmentPage = () => {
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const handleEdit = (department) => {
    setSelectedDepartment(department);
  };

  const handleFormReset = () => {
    setSelectedDepartment(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
        width: '100%',
        flexWrap: { xs: 'wrap', md: 'nowrap' }, 
        p: 2,
      }}
    >
      {/* Table - Left Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 2,
          p: 2,
          minWidth: 0,
        }}
      >
        <DepartmentTable onEdit={handleEdit} />
      </Paper>

      {/* Form - Right Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: 2,
          minWidth: 300,
        }}
      >
        <DepartmentForm
          selectedDepartment={selectedDepartment}
          onReset={handleFormReset}
        />
      </Paper>
    </Box>
  );
};

export default DepartmentPage;
